/**
 * Add or Update user - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object v1/corporate-partner/admin/add-employee
 */
export function configCheck() {
  let url = "v1/users/tmc/panel-config";
  return {
    types: [
      `CONFIG_CHECK_PENDING`,
      `CONFIG_CHECK_FULFILLED`,
      `CONFIG_CHECK_REJECTED`,
    ],
    method: "GET",
    url,
  };
}

/**
 * Add or Update user - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object v1/corporate-partner/admin/add-employee
 */
export function getBookingStatus() {
  let url = "v1/corporate-booking/booking-status";
  return {
    types: [
      `GET_BOOKING_STATUS_PENDING`,
      `GET_BOOKING_STATUS_FULFILLED`,
      `GET_BOOKING_STATUS_REJECTED`,
    ],
    method: "GET",
    url,
  };
}

export function getProfile() {
  return {
    types: [
      `GET_PROFILE_PENDING`,
      `GET_PROFILE_FULFILLED`,
      `GET_PROFILE_REJECTED`,
    ],
    url: `v3/operator/app/config`,
  };
}
